const updateDealDetails = _ref => {
  let {
    types
  } = _ref;
  return function (dealId, dealData) {
    if (dealData === void 0) {
      dealData = {};
    }
    return (dispatch, getState) => {
      const deal = getState().payments?.dealDetails[dealId];
      const newDeal = {
        ...deal
      };
      const propertiesToUpdate = Object.keys(dealData);

      // Merge new details with current state for each key included in the payload
      const newDealData = propertiesToUpdate.reduce((acc, property) => {
        acc[property] = {
          ...acc[property],
          ...dealData[property]
        };
        return acc;
      }, newDeal);
      dispatch({
        type: types.UPDATE_DEAL_DETAILS,
        payload: {
          dealId,
          dealData: newDealData
        }
      });
    };
  };
};
export default updateDealDetails;